import React from 'react';
import { useTranslation } from 'react-i18next';

interface ChatDateHeaderProps {
  date: string; // Дата в формате "2024-01-01"
}

export const ChatDateHeader: React.FC<ChatDateHeaderProps> = ({ date }) => {
  const { i18n } = useTranslation();

  // Форматирование даты
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    
    // Проверяем, сегодня ли это
    const today = new Date();
    const isToday = date.toDateString() === today.toDateString();
    
    // Проверяем, вчера ли это
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    const isYesterday = date.toDateString() === yesterday.toDateString();
    
    if (isToday) {
      return i18n.language === 'ENG' ? 'Today' : 'Сегодня';
    } else if (isYesterday) {
      return i18n.language === 'ENG' ? 'Yesterday' : 'Вчера';
    } else {
      // Форматируем дату в зависимости от языка
      return date.toLocaleDateString(i18n.language === 'ENG' ? 'en-US' : 'ru-RU', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    }
  };

  return (
    <div className="flex justify-center mb-4 chat-date-marker" data-date={date}>
      <div className="bg-header border border-border rounded-lg px-3 py-1 text-sm text-text font-medium">
        {formatDate(date)}
      </div>
    </div>
  );
}; 